
import axios from 'utils/axios' ;


// @ 基礎單 相關 API ( 資料表 : basic )

// [ GET ] ---------------




// [ POST ] ---------------

// 新增 _ 基礎單 ( for React Query )
export const create_Basic = ( obj : any ) => axios.post( "/basics" , obj ) ;



// [ PUT ] ---------------



// [ DELETE ] ---------------
